export const LLM_STATUS_FETCH_INTERVAL_MS = 5 * 60 * 1000;
export const SHOW_LLM_STATUS = false;
